export default __webpack_public_path__ + "static/media/c12.e132f0d4.png";